// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"da9b4e43","lsc":"5004e295","others":"0a619bc7"}[chunkId] + ".chunk.js";
};